import React, { useState, useEffect } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Typography, Paper, Chip } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import styles from './notifications.module.scss'
import RoundButton from "../shared/components/round-btn";
import { ArchiveBox } from "iconsax-react";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import NotificationsUiStore from "./notifications-ui-store";
import AcceptModal from "../shared/accept-modal";
import ReactTimeAgo from 'react-time-ago';
import { getNameFromProfile } from "../../utils/profile-utils";
import DenyModal from "./deny-modal";

const uiStore = new NotificationsUiStore();

const Notifications = observer(({ history, context }) => {
    const [type, setType] = useState('All');
    const { notifications } = uiStore;
    const [notification, setNotification] = useState(null);
    const [showAccpetModal, setShowAccpetModal] = useState(false);
    const [showDenyModal, setShowDenyModal] = useState(false);

    useEffect(() => {
        async function fetchData() {
            uiStore.initliazeContext(context);
            await uiStore.getNotifications();
        }

        fetchData()
    }, [context]);

    const selectNoti = (noti) => {
        setNotification(noti);
        setShowAccpetModal(true);
    }

    const denyNoti = (noti) => {
        setNotification(noti);
        setShowDenyModal(true);
    }

    const deny = async (id) => {
        await uiStore.deny(id);
    }

    return (
        <>
            <Header page="Notifications"></Header>
            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="h5" color='#242333' fontWeight={700}>Notifications</Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: 'center', mt: 2 }}>

                        <Paper variant="round" sx={{ p: 4, width: '100%' }}>
                            <Box sx={{ display: { lg: "flex", sm: 'block' }, justifyContent: 'space-between', mb: 2 }}>
                                <Box sx={{ mb: 2 }}>
                                    <Chip
                                        variant={type === 'All' ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label='All'
                                        onClick={() => setType('All')}
                                    />
                                    <Chip
                                        variant={type === 'Requests' ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label="Requests"
                                        onClick={() => setType('Requests')}
                                    />
                                    <Chip
                                        variant={type === 'Updates' ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label='Updates'
                                        onClick={() => setType('Updates')}
                                    />
                                </Box>
                                <RoundButton variant="contained" color="lightblue"
                                    startIcon={<ArchiveBox
                                        size="24"
                                        variant="Bulk"
                                    />}
                                    onClick={() => setType('archived')}
                                >
                                    Archive
                                </RoundButton>
                            </Box>

                            {type !== 'archived' ?
                                notifications
                                    ?.filter(i => !i.archived)
                                    .filter(i => type === 'All' || (i.notificationType === 'request' && type === 'Requests') || (i.notificationType !== 'request' && type === 'Updates'))
                                    .map(noti => (
                                        <Box key={noti._id}>
                                            <Box className={styles.notificationItem}>
                                                <img src={noti.notificationType === 'request' ? noti.requestingProfiles[0]?.image : noti.profilesRequested[0]?.image} alt='person' />

                                                <Grid container>

                                                    <Grid item xl={10} lg={10} md={10}>
                                                        <Box>
                                                            {noti.notificationType === 'request' ?
                                                                <Typography fontSize='12px'><b>{getNameFromProfile(noti.requestingProfiles[0])}</b> asks you for access to
                                                                    <b>111111{noti.profilesRequested.map(i => ' ' + i.name + ',')}/s</b></Typography>
                                                                :
                                                                <Typography fontSize='12px'><b>{getNameFromProfile(noti.profilesRequested[0])}</b> Granted you access to<b>{noti?.profilesRequested.map((i, index) => <span key={i._id}>{index !== noti.profilesRequested.length - 1 ?' ' + i.name + ',' :  i.name} </span>)} card/s</b></Typography>
                                                            }
                                                        </Box>
                                                        {noti.notificationType === 'request' && noti.message &&
                                                            <Box
                                                                sx={{
                                                                    whiteSpace: 'pre-line', backgroundColor: '#E3E8EF', borderRadius: '16px', p: 2,
                                                                    fontSize: '12px', maxWidth: '400px'
                                                                }}
                                                                className='notification-request-message'
                                                            >
                                                                {noti.message}
                                                            </Box>
                                                        }
                                                        <Typography color='#0090FF' fontSize='12px'><ReactTimeAgo date={noti.createdDate} locale="en-US" /></Typography>
                                                    </Grid>

                                                    {noti.notificationType === 'request' &&
                                                        <Grid item xl={2} lg={2} md={2} className={styles.notificationActions} sx={{ mb: 1 }}>
                                                            <Button color='secondary' sx={{ mr: 1, mt: 3, height: 'fit-content' }} onClick={() => selectNoti(noti)} variant="contained">Accept</Button>
                                                            <Button variant="outlined" sx={{ mr: 2, mt: 3, height: 'fit-content' }} onClick={() => denyNoti(noti)} color='grey'>Deny</Button>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Box>
                                            <Divider sx={{ margin: '4px auto', width: '90%' }} />
                                        </Box>
                                    ))

                                :
                                notifications
                                    ?.filter(i => i.archived)
                                    .map(noti => (
                                        <Box key={noti._id}>
                                            <Box className={styles.notificationItem}>
                                                <img src={noti.notificationType === 'request' ? noti.requestingProfiles[0]?.image : noti.profilesRequested[0]?.image} alt='person' />

                                                <Grid container>

                                                    <Grid item xl={10} lg={10} md={10}>
                                                        <Box>
                                                            {noti.notificationType === 'request' ?
                                                                <Typography fontSize='12px'><b>{getNameFromProfile(noti.requestingProfiles[0])}</b> asks you for access to
                                                                    <b>{noti.profilesRequested.map(i => ' ' + i.name + ',')}/s</b></Typography>
                                                                :
                                                                <Typography fontSize='12px'><b>{getNameFromProfile(noti.profilesRequested[0])}</b> Granted you access to <b>{noti?.profilesRequested.map(i => <span key={i._id}>{i.name} </span>)} card/s</b></Typography>
                                                            }
                                                        </Box>
                                                        {noti.notificationType === 'request' && noti.message &&

                                                            <Box
                                                                sx={{
                                                                    whiteSpace: 'pre-line', backgroundColor: '#E3E8EF', borderRadius: '16px', p: 2,
                                                                    fontSize: '12px', maxWidth: '400px'
                                                                }}
                                                                className='notification-request-message'
                                                            >
                                                                {noti.message}
                                                            </Box>
                                                        }

                                                        <Typography color='#0090FF' fontSize='12px'><ReactTimeAgo date={noti.createdDate} locale="en-US" /></Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Divider sx={{ margin: '4px auto', width: '90%' }} />
                                        </Box>
                                    ))
                            }
                        </Paper>

                        {notification &&
                            <AcceptModal show={showAccpetModal} setShow={setShowAccpetModal} notification={notification} uiStore={uiStore} />
                        }
                        {notification &&
                            <DenyModal show={showDenyModal} setShow={setShowDenyModal} notification={notification} uiStore={uiStore} deny={deny} />
                        }
                    </Box>
                </Box>
            </Grid >
            <Footer></Footer>
        </>
    );
});

export default Notifications;